import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Link,
} from "../../../../../../../components/DesignSystem/Button/Button";

const propTypes = {
  t: PropTypes.func.isRequired,
  url: PropTypes.func.isRequired,
  invitedBy: PropTypes.string.isRequired,
  referralAmount: PropTypes.number.isRequired,
  lang: PropTypes.string.isRequired,
};

const Hero = ({ t, invitedBy, referralAmount, url }) => {
  const openFreshdeskHelpWidget = () => {
    // eslint-disable-next-line new-cap
    window.FreshworksWidget("open");
  };

  return (
    <section className="LandingPage-Hero">
      <div className="LandingPage-Hero-inner">
        <div className="LandingPage-Hero-text">
          <div className="LandingPage-Hero-subtitle">
            <img
              className="LandingPage-Hero-gift"
              src="/public/images/referral/gift.svg"
            />
            <span>
              {t("spages.referrals.landing.sections.Hero.gift", {
                invitedBy,
                referralAmount,
              })}
            </span>
          </div>
          <h2 className="LandingPage-Hero-title">
            {t("spages.referrals.landing.sections.Hero.title")}
          </h2>
          <div className="LandingPage-Hero-ctaWrapper">
            <Link
              className="LandingPage-Hero-createListingBtn"
              colorVariant="primary"
              href={url("createListing")}
              size="medium"
            >
              {t("spages.referrals.landing.sections.Hero.startRenting")}
            </Link>
            <Button
              className="LandingPage-Hero-contactBtn"
              colorVariant="secondary"
              size="medium"
              onClick={openFreshdeskHelpWidget}
            >
              {t("spages.referrals.landing.sections.Hero.contactUs")}
            </Button>
          </div>
        </div>
      </div>
      <div className="LandingPage-Hero-image">
        <img
          srcSet="
            /public/images/referral/Landlord_banner_800.jpg 800w,
            /public/images/referral/Landlord_banner_1200.jpg 1200w,
            /public/images/referral/Landlord_banner_1600.jpg 1600w,
            /public/images/referral/Landlord_banner_2200.jpg 2200w,
            /public/images/referral/Landlord_banner_3200.jpg 3200w"
          sizes="
            (max-width: 768px) 100vw,
            50vw"
          src="/public/images/referral/Landlord_banner_2200.jpg"
        />
      </div>
    </section>
  );
};

Hero.propTypes = propTypes;
export default Hero;
